import { getFilterIds } from "@tIntermatic/Services/DiscontinuedProductsFilterService";
import { DiscontinuedProductListFilterState } from "@tIntermatic/Store/Components/DiscontinuedProductFilter/DiscontinuedProductListFilterState";

export const getDiscontinuedProductListFilters = () => {
    const DiscontinuedProductListFilter: DiscontinuedProductListFilterState = {
        typeFilters: getFilterIds("type"),
        categoryFilters: getFilterIds("category"),
    };
    return DiscontinuedProductListFilter;
};
